{
  "validation.required": "{{label}} on pakollinen kenttä",
  "validation.minLength": "{{label}} on oltava vähintään {{min}} merkkiä pitkä",
  "validation.maxLength": "{{label}} ei voi olla pidempi kuin {{max}} merkkiä",
  "validation.contentTypeAlphanumeric": "{{label}} on oltava aakkosnumeerinen",
  "validation.contentTypeDate": "{{label}} on oltava päivämäärä",
  "validation.contentTypeDateBefore": "{{label}} on oltava päivämäärä ennen {{date beforeDate}}",
  "validation.contentTypeDateAfter": "{{label}} on oltava {{date afterDate}} jälkeinen päivämäärä",
  "validation.contentTypeDatetime": "{{label}} on oltava päivämäärä ja aika",
  "validation.contentTypeDatetimeBefore": "{{label}} on oltava päivämäärä ennen {{datetime beforeDate}}",
  "validation.contentTypeDatetimeAfter": "{{label}} on oltava {{datetime afterDate}} jälkeinen päivämäärä",
  "validation.contentTypeEmail": "{{label}} on oltava sähköposti",
  "validation.contentTypeInteger": "{{label}} on oltava numero",
  "validation.contentTypeNumber": "{{label}} on oltava numero",
  "validation.contentTypeRegex": "{{label}} on väärässä muodossa",
  "validation.contentTypeText": "{{label}} on oltava teksti",
  "validation.contentTypeTime": "{{label}} on oltava aika",
  "validation.contentTypeUrl": "{{label}} on oltava verkko-osoite",
  "select-element.default-option": "Valitse…",
  "button-element.network-required": "Olet tällä hetkellä offline-tilassa. Muodosta verkkoyhteys jatkaaksesi."
}